export const QuickAssistantSetupActionsSection = () => {
  return <div>general settings section here</div>;
};
